import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth } from '@src/hooks/useAuth';
import { LanguagePreferenceProvider } from './LanguagePreferenceProvider';
/**
 * Wrapper component that adapts authentication context for the language preference system.
 * Extracts current user from auth context and transforms it to the format expected by LanguagePreferenceProvider.
 */
export const LanguagePreferenceWrapper = ({ children, productName, segmentAnalytics, }) => {
    const { currentUser } = useAuth();
    // Map the auth user to our UserType format
    const user = currentUser
        ? {
            id: String(currentUser.id || ''),
            firstName: currentUser.firstName,
            lastName: currentUser.lastName,
            email: currentUser.email,
            employeeId: currentUser.employeeId?.toString(),
            clientId: currentUser.clientId?.toString(),
        }
        : undefined;
    return (_jsx(LanguagePreferenceProvider, { productName: productName, segmentAnalytics: segmentAnalytics, user: user, children: children }));
};
